import React, { useEffect, useState } from "react";
import TaxesForm from "./tax_form";
import { Delete, Pen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import { createTax, deleteTax, fetchTaxes, updateTax } from "../../../../slices/company/taxSlices";
import Swal from "sweetalert2";
import { customTableStyles } from "../../../../utils/tableStylings";

const Taxes = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedTaxes, setSelectedTax] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const { taxes } = useSelector(state => state.accountingTaxes);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchTaxes(companyId));
        }
    }, [dispatch]);


    const handleFormSubmit = (formData) => {
        if (selectedTaxes && selectedTaxes?.id != null) {
            dispatch(updateTax({ id: selectedTaxes.id, taxData: formData }));
        } else {

            dispatch(createTax(formData));
        }
        setShowModal(false);
    };


    const handleEditTax = (taxData) => {
        setSelectedTax(taxData);
        setModalHeading('Edit Tax Rate') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Tax Rates.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteTax(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Tax Rates has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const taxesColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Tax Name',
            selector: row => row.name,
            sortable: true
        },

        {
            name: 'Tax Rate',
            selector: row => row.rate,
            sortable: true
        },
        {
            name: 'HSN/SAC Code',
            selector: row => row.hsn_code,
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '150px'
        }
    ];

    const handleAdd = () => {
        setSelectedTax([]);
        setModalHeading('Create Tax Rate');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="text-primary mb-0">Taxes</h3>
                        <button
                            className="btn btn-primary"
                            onClick={() => handleAdd()}
                        >
                            + Add Tax
                        </button>
                    </div>
                </div>
                <div className="card-body">

                    {
                        taxes && taxes.length > 0 ? (
                            <DataTable

                                columns={taxesColumn}
                                data={taxes}
                                pagination
                                highlightOnHover
                                striped
                                dense
                                customStyles={customTableStyles}
                            />
                        ) : (
                            <p>No Data Found</p>
                        )
                    }
                </div>
            </div>
            <TaxesForm show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedTaxes} onSubmit={handleFormSubmit} />
        </>
    );
}

export default Taxes;